import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import SectionTitle from 'app/components/common/SectionTitle';
import CustomScroller from 'app/components/common/CustomScroller';
import SpendOfferCard from 'app/components/derived/offer/SpendOfferCard';
import CouponCard from 'app/components/derived/offer/CouponCard';
import ProductThumb from 'app/components/common/ProductThumb';
import CategoryThumb from 'app/components/common/CategoryThumb';
import BannerMiddle from 'app/components/common/homepage/BannerMiddle';
import FeaturedBanner from 'app/components/common/homepage/FeaturedBanner';
import * as BrandSpaceActionTypes from 'app/store/brand-space/actions';
import * as HomeNewActionTypes from 'app/store/home/actions';
import * as SuperSavingsActionTypes from 'app/store/super-savings/actions';
import { useSelector, useDispatch } from 'react-redux';
import ScratchCards from 'app/components/common/ScratchCards';
import BannerTop from '../../components/common/homepage/BannerTop';
import QuickCard from '../../components/common/QuickCard';
import Footer from '../../layout/footer/Footer';
import FooterMobile from '../../layout/footer/FooterMobile';
import { Constants } from '../../utilities';
import * as ctEvents from '../../events/Events';
import * as buttonActions from '../../events/buttonActions';
import * as screens from '../../events/screens';
import { CustomModal, Svg, Placeholder } from 'app/components/common';
import StoreCard from 'app/components/common/StoreCard';
import { Spinner } from 'react-bootstrap';
import ReferFriendInfo from 'app/layout/refer-friends/ReferFriendInfo';
// import * as Actions from '../../store/Actions';
import ReferShop from 'app/components/common/ReferShop';
import { Helmet } from 'react-helmet';
import DefaultGuestLocationAlert from 'app/components/common/DefaultGuestLocationAlert';
import StaticContent from './StaticContent';
import { fbLogPageView } from '../../../facebook/Facebook';
import OrderTracking from 'app/components/derived/orderTracking';
import { activeOrderActions } from 'app/store/orders/action';
import { isAlreadyLoggedIn } from 'app/utilities/Utils';
import { cqHomepageTag } from 'app/criteoq';
import { gaLogCustomEvents, gaLogPageView } from 'ecommerce_ga_events/EcommerceGAEvents';
import '../../styles/home/homeNew.scss';
import { buttonEventClick } from 'clevertap/LogEvent';
import Event from 'clevertap/Event';
import { Link } from 'react-router-dom';
import { getSessionId } from 'app/utilities/Storage';

const isMobile = window.screen.width < 992;

const Home = (props) => {
  const { history, language, showReferNEarn } = props;

  const pageMeta = (
    <Helmet>
      <title>
        Online grocery shopping from trusted Kirana Stores | LoveLocal
      </title>
      <meta
          name="description"
          content="Get best prices on Grocery items, Fruits & Vegetables, Medicines & more at your nearby Kirana stores on LoveLocal. Shop local today!"
      />
      <link
          rel="canonical"
          href={`https://${window.location.host}/`}
      />

      {/* Home Page basic BreadCrumb Details */}
      <script type="application/ld+json">
          {JSON.stringify({
              '@context': 'https://schema.org/',
              '@type': 'Organization',
              address: {
                  '@type': 'PostalAddress',
                  addressLocality: 'Goregaon East, Mumbai, Maharashtra',
                  postalCode: '400063',
                  streetAddress: 'WeWork, 1st Floor, Commerz II,Oberoi Garden City',
              },
              email: 'cs@lovelocal.in',
              faxNumber: '+91 8448448906',
              name: 'LoveLocal',
              telephone: '+91 8448448906',
          })}
      </script>
    </Helmet>
  );

  const {
    homeNew,
    brandSpaces,
    superSavings,
    selectedAddress,
    requestsProcessing,
    requestsFailure,
    customer,
  } = useSelector((state) => state.main);

  const dispatch = useDispatch();

  const loadHomeNew = () => {
    dispatch(HomeNewActionTypes.homeNewLoadActions.loadRequest(null, {isFreeSample :true}));
  };
  const loadBrandSpaces = () => {
    dispatch( BrandSpaceActionTypes.brandSpaceLoadActions.loadRequest( null, null, '', {
      requestFrom: 'WEB',
      page: 'HOME',
    }));
  };
  const loadSuperSavings = () => {
    dispatch( SuperSavingsActionTypes.superSavingsLoadActions.loadRequest('',{isFreeSample :true}));
  };
  const loadActiveOrders = () => {
    dispatch(activeOrderActions.loadRequest())
  };

  const loadAllAPIS = () => {
    loadHomeNew();
    loadBrandSpaces();
    loadSuperSavings();
    if (isAlreadyLoggedIn()) {
      loadActiveOrders();
    }
  }

  const {
    [HomeNewActionTypes.HOME_NEW_LOAD_REQUEST]: processingHomeNew,
  } = requestsProcessing;
  const {
    [HomeNewActionTypes.HOME_NEW_LOAD_REQUEST]: failureHomeNew,
  } = requestsFailure;
  const {
    [BrandSpaceActionTypes.BRAND_SPACE_LOAD_REQUEST]: processingBrandSpaces,
  } = requestsProcessing;

  useEffect(() => {
    const sessionId = getSessionId();
    const gaLogData = {
      sessionId,
      phoneNo: customer?.phone_number,
      userId: customer?.uid,
      area: selectedAddress?.addressText,
      pinCode: selectedAddress?.pinCode,
      hexId: selectedAddress?.locationId,
      city: selectedAddress?.localityName,
    };
    gaLogCustomEvents(
      'web_Home_page_Launched',
      gaLogData,
    );
  }, []);

  useEffect(() => {
    loadAllAPIS()
    ctEvents.logPageLoad({
      SCREEN: screens.HOME_SCREEN,
    });
    gaLogPageView();
    fbLogPageView();
    cqHomepageTag();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddress]);

  useEffect(() => {
      if (!processingHomeNew && homeNew && homeNew?.banners && homeNew?.banners.length > 0){
        (homeNew?.banners).forEach((banner) => {
          if (banner.bannerLocation === 'BANNER_TOP' || banner.bannerLocation === 'BANNER_BOTTOM') {
            captureBannerImpression(banner, 'Banner Top')
          }
          if (banner.bannerLocation === 'BANNER_MIDDLE') {
            captureBannerImpression(banner, 'Banner Middle')
          }
        })
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeNew])

  useEffect(() => {
      if (!processingBrandSpaces && brandSpaces && brandSpaces?.featured && brandSpaces?.featured.length > 0){
        (brandSpaces?.featured).forEach((banner) => {
          CaptureBrandBannerImpression(banner, "Featured")
        })
      }
      if (!processingBrandSpaces && brandSpaces && brandSpaces?.focusToday && brandSpaces?.focusToday.length > 0){
        (brandSpaces?.focusToday).forEach((banner) => {
          CaptureBrandBannerImpression(banner, "In_Focus")
        })
      }
      if (!processingBrandSpaces && brandSpaces && brandSpaces?.mustTry && brandSpaces?.mustTry.length > 0){
        (brandSpaces?.mustTry).forEach((banner) => {
          CaptureBrandBannerImpression(banner, "Must_Try")
        })
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandSpaces])


  const [showBrandVideoModal, setShowBrandVideoModal] = useState(false);
  const [brandVideoLink, setBrandVideoLink] = useState('');
  const [showReferAndEarn, setshowReferAndEarn] = useState(showReferNEarn);

  const onSetBrandVideoLink = (banner) => {
    setBrandVideoLink(`${banner.deepLink.web}?autoplay=1`);
  };

  const OnToggleVideoModal = () => {
    setShowBrandVideoModal(!showBrandVideoModal);
  };

  const brandVideoFrame = (
    <div className='r__brandVideoFrame'>
      <iframe
        title="YouTube video player"
        width="992"
        height="558"
        src={brandVideoLink}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        autoPlay
      />
    </div>
  );

  const captureBannerImpression = useCallback((banner, section) => {
    if(banner){
      ctEvents.logBannerImpression(
        {          
          'Page': screens.HOME_TAB,
          'banner_name': banner.title,
          section
        }
      )
    }
  }, [])

  const CaptureBrandBannerImpression = useCallback((banner, section) => {
    if(banner){
      ctEvents.logBrandBannerImpression(
        {
          'Page': screens.HOME_TAB,
          'banner_name': banner.name,
          section,
        }
      )
    }
  }, [])

  const handleCaptureBannerClicked = useCallback((banner, section) => {
    if(banner){
      ctEvents.logBannerClicked(
        {
          'Page': screens.HOME_TAB,
          'banner_name': banner.title,
          section
        }
      );
    }
  }, []);

  const handleCaptureBrandBannerClicked = useCallback((banner, section) => {
    if(banner){
      ctEvents.logBrandBannerClicked(
        {
          'Page': screens.HOME_TAB,
          'banner_name': banner.name,
          section,
          id: banner.bannerId,
          image: (isMobile) ? banner.image : banner.webimage,
        }
      )
    }
  }, [])

  function getQuickItemName(name){
    switch(name){
      case "Smart Basket" : return "LLEasy_Shops"
      case "Best In Offers" : return "Best In Offers"
      case "Trending Products" : return "Trending Products"
      default: return null;
    }
  }

  return (
    <>
      {
        (processingHomeNew && !homeNew)
        && (
          <>
            {pageMeta}
            <div
              className="r__loader"
            >
              <Spinner
                animation="border"
                variant="primary"
              />
            </div>
          </>  
        )
      }
      {
        (failureHomeNew && !processingHomeNew && !homeNew)
        && (
          <>
          {pageMeta}
            <div className='r__loader'>
              <Placeholder
                language={language}
                handleRetry={loadAllAPIS}
                imageSrc="/images/error-placeholder.png"
                heading={Constants.String.OH_NO[language]}
              />
            </div>
          </>  
        )
      }
      {
        (homeNew)
        &&
        <>
          {pageMeta}
          <DefaultGuestLocationAlert {...props} />
          {!isMobile && 
            <OrderTracking
              {...props}
              page="Home"
            />
          }
          <div className="r__container">
            <CustomModal
              show={showReferAndEarn}
              title={Constants.String.REFER_AND_EARN[language]}
              closeButton
              onHide={() => setshowReferAndEarn(false)}
              body={(
                <ReferFriendInfo
                  {...props}
                  onHide={() => setshowReferAndEarn(false)}
                />
              )}
            />
            <CustomModal
              show={showBrandVideoModal}
              title=" "
              size="lg"
              body={brandVideoFrame}
              centered
              closeButton
              backdrop
              onHide={() => OnToggleVideoModal()}
            />
            {
              (homeNew?.stores.length > 0) ? (
                <>
                  <section className="r__section r__section_banner">
                    <BannerTop
                      banners={homeNew?.banners}
                      setBrandVideoLink={onSetBrandVideoLink}
                      toggleVideoModal={OnToggleVideoModal}
                      captureBannerClicked = {handleCaptureBannerClicked}
                      {...props}
                    />
                  </section>
                  <section className="r__section r__section_first">
                    {
                      (homeNew?.repeatOrderStores.length === 1 && homeNew?.repeatOrderProducts.length > 0) ?
                      (
                        <>
                          <SectionTitle
                            titleCopy={homeNew?.repeatOrderStores[0].name}
                            hasBtn
                          >
                            <button
                              type="button"
                              className='r__title_link-btn'
                              onClick={() => {
                                ctEvents.logButtonClick(
                                  {
                                    BUTTON: buttonActions.FAVOURITE_SHOP,
                                    SCREEN: screens.HOME_SCREEN,
                                  },
                                );
                                history.push(`/shops/${homeNew?.repeatOrderStores[0].storeId}`);
                              }}
                            >
                              {Constants.String.SHOP_NOW[language].toLowerCase()}
                              <Svg
                                svg='arrowRightNew'
                                stroke={Constants.Color.primary}
                                width="18px"
                              />
                            </button>
                          </SectionTitle>
                          <CustomScroller
                            noMargin
                            content={(
                              <div className="r__flex r__flex-20">
                                {homeNew?.repeatOrderProducts.map((product) => (
                                  <ProductThumb
                                    key={product.libraryProductId}
                                    {...props}
                                    libraryProductId={product.libraryProductId}
                                    retailProductId={product.id}
                                    name={product.name}
                                    image={product.image}
                                    mrp={product.mrp}
                                    sellingPrice={product.sellingPrice}
                                    measurementDisplayText={product.measurementDisplayText}
                                    storeName={product.store.name}
                                    storeId={product.store.id}
                                    offerPercent={product.offerPercent}
                                    section="Home repeat order products"
                                  />
                                ))}
                              </div>
                            )}
                            contentPrefix="repeatOrderProducts"
                          />
                        </>
                      ) : null
                    }
                    {
                      (homeNew?.repeatOrderStores.length > 1) ?
                      (
                        <>
                          <SectionTitle
                            titleCopy="Your Favourite Shops"
                            hasBtn
                          >
                            <button
                              type="button"
                              className='r__title_link-btn'
                              onClick={() => {
                                ctEvents.seeAllFavouriteShopsClicked(
                                  {
                                    Page: screens.HOME_TAB,
                                  },
                                );
                                history.push('/shops/g/favourites-101');
                              }}
                            >
                              {Constants.String.SEE_ALL[language]}
                              <Svg
                                svg='arrowRightNew'
                                stroke={Constants.Color.primary}
                                width="18px"
                              />
                            </button>
                          </SectionTitle>
                          <CustomScroller
                            noMargin
                            content={(
                              <div className="r__flex r__flex-24">
                                {homeNew?.repeatOrderStores.map((store) => (
                                  <StoreCard
                                    key={store.storeId}
                                    {...props}
                                    item={store}
                                    screen={screens.HOME_SCREEN}
                                  />
                                ))}
                              </div>
                            )}
                            contentPrefix="repeatOrderProductsStores"
                          />
                        </>
                      ) : null
                    }
                  </section>

                  {
                    (superSavings?.superSavings.length > 0) ?
                    (
                      < section className="r__section">
                        <SectionTitle
                          titleCopy="super savings for you"
                          hasLink={false}
                        />
                        <CustomScroller
                          noMargin
                          content={(
                            <div className="r__flex r__flex--linear r__flex-10">
                              {
                                superSavings?.superSavings?.map((card) => (card.type === 'FREE_SAMPLE')
                                  ? (
                                    <Link
                                      key={card.type}
                                      className='r__refer_card free_sample_bg'
                                      to={{
                                        pathname: '/shops',
                                        state: {
                                          filterCategoryId: 'FREESAMPLE',
                                          filterId: 'FREE_SAMPLE',
                                          scrollToTop: true,
                                        },
                                      }}
                                      onClick={() => {
                                        buttonEventClick(
                                          Event.LL_Banner_Clicked,
                                          {
                                            Page: screens.HOME_TAB,
                                            'Banner name': 'Free Sample',
                                            Section: 'Super Savings',
                                          },
                                        )
                                      }}
                                    >
                                      <img 
                                        src={card.image} 
                                        alt={card.name} 
                                      />
                                    </Link>
                                  ) : null)
                              }
                              {
                                superSavings?.superSavings?.map((card) => (card.type === 'REFER_AND_EARN')
                                  ? (
                                    <div
                                      key={card.type}
                                      className='r__refer_card'
                                      onClick={() => {
                                        setshowReferAndEarn(true)
                                        ctEvents.logBannerClicked(
                                          {
                                            'Page': screens.HOME_TAB,
                                            'banner_name': 'Refer',
                                            'Banner_Section' : 'Super Savings',
                                          },
                                        );
                                      }}
                                    >
                                      <img src={card.image} alt={card.name} />
                                    </div>
                                  ) : null)
                              }
                              {
                                superSavings?.superSavings?.map((card) => (card.type === 'SCRATCH_CARD')
                                  ? (
                                    <ScratchCards
                                      {...props}
                                      key={card.type}
                                      item={card}
                                      page={screens.HOME_TAB}
                                    />
                                  ) : null)
                              }
                              {
                                superSavings?.superSavings?.map((card) => (card.type === 'SPEND_OFFERS' || card.type === 'VALUE_OFFERS')
                                  ? (
                                    <SpendOfferCard
                                      {...props}
                                      key={card.id}
                                      item={card}
                                      page={screens.HOME_TAB}
                                    />
                                  ) : null)
                              }
                              {
                                superSavings?.superSavings?.map((card) => (card.type === 'COUPONS')
                                  ? (
                                    <CouponCard
                                      key={card.id}
                                      item={card}
                                      {...props}
                                      page={screens.HOME_TAB}
                                    />
                                  ) : null)
                              }
                              <div
                                className="r__all_offers"
                                onClick={() => {
                                  ctEvents.seeAllClicked(
                                    {
                                      Page: screens.HOME_TAB,
                                      Section: 'Super Savings',
                                    },
                                  );
                                  history.push({ pathname: '/offers'});
                                }}
                              >
                                <span>See All Offers</span>
                                <Svg
                                  svg='arrowRightRound'
                                />
                              </div>
                            </div>
                          )}
                          contentPrefix="superSavingsForYou"
                        />
                      </section>
                    ) : null
                  }

                  {
                    (homeNew?.stores.length > 0) ?
                    (
                      <section className="r__section">
                        <SectionTitle
                          titleCopy="Discover Shops near You"
                          hasBtn
                        >
                          <button
                            type="button"
                            className='r__title_link-btn'
                            onClick={() => {
                              ctEvents.seeAllClicked(
                                {
                                  Page: screens.HOME_TAB,
                                },
                              );
                              history.push('/shops');
                            }}
                          >
                            {Constants.String.SEE_ALL[language]}
                            <Svg
                              svg='arrowRightNew'
                              stroke={Constants.Color.primary}
                              width="18px"
                            />
                          </button>
                        </SectionTitle>
                        <CustomScroller
                          noMargin
                          content={(
                            <div className="r__flex r__flex-20">
                                {
                                  homeNew?.stores.map((store) => (
                                    <StoreCard
                                      key={store.storeId}
                                      item={store}
                                      {...props}
                                      screen={screens.HOME_TAB}
                                    />
                                  ))
                                }
                                <ReferShop 
                                  {...props} 
                                  isRevamped={true} 
                                  screen={screens.HOME_TAB}
                                />
                            </div>
                          )}
                          contentPrefix="storesNearMe"
                        />
                      </section>
                    ) : null
                  }

                  {
                    (homeNew?.storeCategories.length > 0) ?
                    (
                      <section className="r__section">
                        <SectionTitle
                          titleCopy="shop by category"
                          hasLink={false}
                        />
                        <CustomScroller
                          noMargin
                          content={(
                            <div className="r__flex r__flex-20">
                              {
                                homeNew?.storeCategories.map((category) => (
                                  <CategoryThumb
                                    {...props}
                                    key={category.id}
                                    category={category}
                                    page={screens.InitialTabFragment}
                                  />
                                ))
                              }
                            </div>
                          )}
                          contentPrefix="storeCategories"
                        />
                      </section>
                    ) : null
                  }

                  {
                    (homeNew?.quickCheckout.length > 0) ?
                      (
                        <section className="r__section">
                          <CustomScroller
                            noMargin
                            content={(
                              <div 
                                className="r__flex r__flex-16"
                              >
                                {
                                  homeNew?.quickCheckout.map((card) => 
                                    (
                                      <Link
                                        to={card.webDeepLink}
                                        key={card.name}
                                        onClick={ () => {
                                            ctEvents.logBannerClicked(
                                              {
                                                PAGE: screens.HOME_TAB,
                                                Banner_Name: getQuickItemName(card.name),
                                                SECTION: 'Section below Middle Banners',
                                              },
                                            )
                                          }
                                        }
                                      >
                                        <QuickCard
                                          name={card.name}
                                          link={card.webDeepLink}
                                          image={card.image}
                                          cardStyle={
                                            {
                                              width: '375px',
                                              height: '270px',
                                              overflow: 'hidden',
                                              borderRadius: '16px',
                                            }
                                          }
                                        />
                                      </Link>
                                    ))
                                }
                              </div>
                            )}
                            contentPrefix="quickCheckout"
                          />
                        </section>
                      ) : null
                  }
                  {
                    (homeNew?.banners.length > 0) &&
                    (
                      <section className="r__section">
                        <CustomScroller
                          noMargin
                          content={(
                            <div className="r__flex r__flex-10">
                              <BannerMiddle
                                banners={homeNew?.banners}
                                brandVideoLink={brandVideoLink}
                                setBrandVideoLink={onSetBrandVideoLink}
                                toggleVideoModal={OnToggleVideoModal}
                                captureBannerClicked = {handleCaptureBannerClicked}
                                {...props}
                              />
                            </div>
                          )}
                          contentPrefix="bannerMiddle"
                        />

                      </section>
                    )
                  }
                  {
                    (brandSpaces?.featured.length > 0) ?
                      (
                        <section className="r__section r__section_banner">
                          <SectionTitle
                            titleCopy="Featured"
                            hasLink={false}
                          />
                          <FeaturedBanner
                            banners={brandSpaces?.featured}
                            captureBrandBannerClicked = {handleCaptureBrandBannerClicked}
                            {...props}
                          />
                        </section>
                      ) : null
                  }

                  {
                    (brandSpaces?.focusToday.length > 0) ?
                      (
                        <section className="r__section">
                          <SectionTitle
                            titleCopy="In Focus Today"
                            hasLink={false}
                          />
                          <CustomScroller
                            noMargin
                            content={(
                              <div className="r__flex r__flex-28">
                                {brandSpaces?.focusToday?.map((brand) => (
                                  <button
                                    key={brand.brandId}
                                    type="button"
                                    className='r__button_clean'
                                    onClick={() => {
                                      handleCaptureBrandBannerClicked(brand, 'in_focus')
                                      history.push(`/brands/${brand.name.toLowerCase()}-${brand.brandId}`)
                                    }}
                                  >
                                    <QuickCard
                                      name={brand.name}
                                      image={(isMobile) ? brand.image : brand.webimage}
                                      cardStyle={
                                        {
                                          width: isMobile ? '140px' : '350px',
                                          height: isMobile ? '180px' : '222px',
                                          overflow: 'hidden',
                                          borderRadius: '16px',
                                        }
                                      }
                                    />
                                  </button>
                                ))}
                              </div>
                            )}
                            contentPrefix="inFocusToday"
                          />
                        </section>
                      ) : null
                  }

                  {
                    (brandSpaces?.mustTry.length > 0) ?
                      (
                        <section className="r__section">
                          <SectionTitle
                            titleCopy="Must Try"
                            hasLink={false}
                          />
                          <CustomScroller
                            noMargin
                            content={(
                              <div className="r__flex r__flex-20">
                                {
                                  brandSpaces?.mustTry?.map((product) => (
                                    <button
                                      key={product.productId}
                                      type="button"
                                      className='r__button_clean'
                                      onClick={() => {
                                        handleCaptureBrandBannerClicked(product, 'must_try')
                                        history.push(`/search?q=${product.name}`)
                                      }}
                                    >
                                      <QuickCard
                                        name={product.name}
                                        image={(isMobile) ? product.image : product.webimage}
                                        cardStyle={
                                          {
                                            width: '250px',
                                            height: '180px',
                                            overflow: 'hidden',
                                            borderRadius: '16px',
                                          }
                                        }
                                      />
                                    </button>  
                                  ))
                                }
                              </div>
                            )}
                            contentPrefix="mustTry"
                          />
                        </section>
                      ) : null
                  }

                  <section className='r__section'>
                    <StaticContent />
                  </section>

                  <section className='r__section mt-4'>
                    <div
                      className="r__faq"
                      onClick={() => {
                        ctEvents.logButtonClick(
                            {
                                BUTTON: buttonActions.FAQ,
                                SCREEN: screens.HOME_SCREEN,
                            },
                        );
                        history.push('/faq')
                      }}
                    >
                        {Constants.String.EXPLORE_FAQS[language]}
                    </div>
                  </section>
                </>
              ) : null
            }
          </div >
          
          {/* Footer Start */}
          <div className="d-md-none bg-black mt-2">
            <FooterMobile {...props} />
            <div className="p-6" />
          </div>

          <div className="d-none d-md-block bg-black mt-4">
            <Footer {...props} />
          </div>
          {/* Footer End */}
        </>  
      }
    </>
  );
};

Home.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  language: PropTypes.string.isRequired,
  showReferNEarn: PropTypes.bool,
};

export default Home;